"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_230)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_230`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H30V24.0002H-6V-0.00012207Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 18.7496C15.7279 18.7496 18.75 15.7276 18.75 11.9996C18.75 8.27171 15.7279 5.24963 12 5.24963C8.27208 5.24963 5.25 8.27171 5.25 11.9996C5.25 15.7276 8.27208 18.7496 12 18.7496Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.8315 9.41895L13.9896 11.0147L15.865 10.4066L14.7052 12.001L15.8631 13.5967L13.9883 12.9863L12.8285 14.5807L12.8296 12.6092L10.9548 11.9987L12.8304 11.3906L12.8315 9.41895Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.5341 15.9885C11.3312 15.9885 9.54548 14.2027 9.54548 11.9998C9.54548 9.79694 11.3312 8.01121 13.5341 8.01121C14.221 8.01121 14.8672 8.18488 15.4315 8.49067C14.5463 7.62513 13.3359 7.09082 12 7.09082C9.28891 7.09082 7.09094 9.28872 7.09094 11.9999C7.09094 14.7111 9.28891 16.909 12 16.909C13.3359 16.909 14.5464 16.3747 15.4315 15.5091C14.8672 15.8148 14.221 15.9885 13.5341 15.9885Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_230`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TNFlag };
